// src/api/index.js
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

async function request(path, opts = {}) {
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      headers: { 'Content-Type': 'application/json' },
      ...opts,
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error('API error:', path, err);
    throw err;
  }
}

export const api = {
  fetchState: () => request('/state'),
  addResource: (payload) => request('/add_resource', { method: 'POST', body: JSON.stringify(payload) }),
  addContainer: (payload) => request('/add_container', { method: 'POST', body: JSON.stringify(payload) }),
  addLocation: (payload) => request('/add_location', { method: 'POST', body: JSON.stringify(payload) }),
  moveResource: (payload) => request('/move_resource', { method: 'POST', body: JSON.stringify(payload) }),
  moveContainer: (payload) => request('/move_container', { method: 'POST', body: JSON.stringify(payload) }),
  resizeContainer: (payload) => request('/resize_container', { method: 'POST', body: JSON.stringify(payload) }),
  deleteResource: (id) => request(`/delete_resource/${id}`, { method: 'DELETE' }),
  deleteContainer: (id) => request(`/delete_container/${id}`, { method: 'DELETE' }),
  deleteLocation: (id) => request(`/delete_location/${id}`, { method: 'DELETE' }),
  clearAll: () => request('/clear', { method: 'POST' }),
};